import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class maskReportPackService {
  constructor(private apiService: ApiService) { }

  downloadMaskedFile(model: any) {
    const params = {
      reportPackId: model.reportPackId,
      reportPackTitle: model.reportPackTitle.replace(/[^a-zA-Z0-9]/g, '')
    };
    const promise = new Promise((resolve, reject) => {
      this.apiService.getFile('maskReportPack/DownloadMaskedReportPack/', params, 'application/json')
        .toPromise()
        .then(
          res => { // Success
            this.downloadFile(res)
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  downloadFile(data: any) {
    let blob = data.body;
    const contentHeader = data.headers.get('content-disposition');
    if (contentHeader !== null && blob !== null) {
      let fileName = data.headers.get('content-disposition').split(';')[1].trim().split('=')[1].replace(/"/g, '');
      saveAs(blob, fileName);
    }
  }

}